<template>
	<v-tab-item>
		<v-card flat>
			<h3 class="text-h6 font-weight-bold">検査情報</h3>
			<v-card-text class="pa-0"></v-card-text>
		</v-card>
	</v-tab-item>
</template>

<script>
export default {}
</script>

<style></style>
